import {CategoryCampaignLoading, IInternalState} from "./context";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import paramsReducer, {QueryAction} from "../base/base-reducer";
import toggleLoading from "../../utils/helpers/xor";
import {ICategoryCampaign, ICategoryCampaignDetails} from "../../models/category_campaign/response";
import {ICategoryCampaignQuery} from "../../models/category_campaign/query";


type Action =
    | {
    type: "LOADING";
    payload: { loading: CategoryCampaignLoading | CategoryCampaignLoading[] };
}
    | { type: "SET_LIST"; payload: { list: IBaseListingResponse<ICategoryCampaign> } }
    | { type: "SET_DETAILS"; payload: { details?: ICategoryCampaignDetails } }
    | QueryAction<ICategoryCampaignQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
    switch (action.type){
        case "LOADING": {
            return {
                ...state,
                loading: toggleLoading(state.loading, action.payload.loading),
            };
        }
        case "SET_LIST": {
            return {
                ...state,
                list: action.payload.list,
            };
        }
        case "SET_DETAILS": {
            return {
                ...state,
                details: action.payload.details,
            };
        }
        default: {
            return paramsReducer(state, action);
        }
    }
}

export default reducer;
